"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var services_1 = require("../../services");
var mobx_2 = require("../../state/mobx");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var upload_reader_1 = require("../../util/upload.reader");
var multi_list_chooser_style_1 = require("../multi.list.chooser//multi.list.chooser.style");
var multi_list_chooser_1 = require("../multi.list.chooser/multi.list.chooser");
var span_link_chooser_state_1 = require("../multi.list.chooser/span.link.chooser.state");
var collection_change_state_1 = require("./collection.change.state");
var CollectionEditCtrl = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionEditCtrl, _super);
    function CollectionEditCtrl(state) {
        var _this = _super.call(this) || this;
        _this.isFormOpen = mobx_1.observable.map({}, { deep: false });
        _this.isFieldDetailShown = mobx_1.observable.map({}, { deep: false });
        _this.lastCollectionId = null;
        _this.isAllExpanded = true;
        _this.isInEditMode = false;
        _this.isSaving = false;
        _this.isMetadataShown = false;
        _this.isZoomShown = true;
        _this.isPhotomeasure = false;
        /** File upload */
        _this.maxFileSize = 1000 * 1000 * 10; // 10 Megabyte
        _this.maxImageSize = 1000 * 1000 * 4; // 4 Megabyte
        _this.allowedTypes = [];
        _this.isInUploadMode = false;
        _this.fieldsInLoadingState = [];
        _this.file = null;
        _this.image = null;
        _this.kind = 'CollectionEditCtrl';
        _this.mapState = state;
        _this.changeState = new collection_change_state_1.CollectionChangeState();
        _this.reaction(function (_) { return _this.collection; }, _this.updateEditedCollection);
        _this.reaction(function (_) { return _this.file && _this.file.buffer; }, _this.processFile);
        _this.reaction(function (_) { return _this.image && _this.image.buffer; }, _this.processImage);
        services_1.Services.Window.bindNavigateAway(index_1.T.DISCARD_CHANGES_CONFIRM, _this.stopNavigation);
        return _this;
    }
    CollectionEditCtrl.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.changeState) {
            this.changeState.destroy();
        }
        services_1.Services.Window.unbindNavigateAway(this.stopNavigation);
        if (page_state_1.CurrentState.CollectionEdit.collectionRevision) {
            page_state_1.CurrentState.CollectionEdit.reset();
        }
    };
    Object.defineProperty(CollectionEditCtrl.prototype, "collection", {
        get: function () {
            return page_state_1.CurrentState.CollectionEdit.collection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isCollectionLoading", {
        get: function () {
            if (!page_state_1.CurrentState.inspectedCollectionRevision) {
                return false;
            }
            return !store_1.AppStore.Collection.has(page_state_1.CurrentState.inspectedCollectionRevision);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isCollectionSelected", {
        get: function () {
            return page_state_1.CurrentState.inspectedCollectionRevision != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isEditing", {
        get: function () {
            return this.changeState != null && (this.isInEditMode || this.isPhotomeasure);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isValid", {
        get: function () {
            return this.changeState != null && this.changeState.isValid && !this.isInUploadMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isEditable", {
        get: function () {
            return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_EDIT);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "useColorCoding", {
        get: function () {
            return services_1.Services.Token.has(core_api_1.IkeToken.PHOTOMEASURE_COLOR_CODING);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditCtrl.prototype, "isUploading", {
        get: function () {
            return this.changeState != null && this.isInUploadMode;
        },
        enumerable: false,
        configurable: true
    });
    CollectionEditCtrl.prototype.clearOpenState = function () {
        this.isFormOpen.clear();
        this.isFieldDetailShown.clear();
    };
    CollectionEditCtrl.prototype.updateEditedCollection = function () {
        var currentCollection = this.collection;
        if (currentCollection == null) {
            this.lastCollectionId = null;
            if (this.changeState != null) {
                this.changeState.destroy();
            }
            this.changeState = null;
            this.isInEditMode = false;
        }
        else if (this.lastCollectionId !== currentCollection.revision) {
            this.clearOpenState();
            this.lastCollectionId = currentCollection.revision;
            if (this.changeState != null) {
                this.changeState.destroy();
            }
            this.changeState = new collection_change_state_1.CollectionChangeState();
            this.isInEditMode = false;
        }
    };
    CollectionEditCtrl.prototype.abortChanges = function (e) {
        var _this = this;
        e.preventDefault();
        this.mapState.checkAndDiscardChanges().then(function (shouldDiscard) {
            if (shouldDiscard && _this.changeState != null) {
                _this.discardAndDestroyEdit();
            }
        });
        return false;
    };
    CollectionEditCtrl.prototype.discardAndDestroyEdit = function () {
        if (this.changeState != null) {
            var draw = page_state_1.CurrentState.CollectionEdit.currentDraw;
            if (draw != null) {
                // Reset brightness state
                draw.state.setBrightness(draw.state.defaultBrightness);
                // Reset the image visibility state
                draw.state.setImageVisibilityHidden(draw.state.defaultImageVisibilityHidden);
                // Reset the crop state
                var crop = draw.state.defaultCrop;
                draw.state.setCrop(crop.x, crop.y, crop.width, crop.height);
            }
            //discard everything
            while (page_state_1.CurrentState.CollectionEdit.isDirty) {
                page_state_1.CurrentState.CollectionEdit.discard();
            }
            // After everything has been reset, display the crosshair depending if there are any measurements
            if (draw != null) {
                if (draw.state.areInsightDetectionsVisible && draw.drawState.hasInsightDetections()) {
                    draw.state.setCrosshair(false);
                }
                else {
                    draw.state.setCrosshair(!draw.drawState.hasUserMeasurements());
                }
            }
        }
        this.changeState = new collection_change_state_1.CollectionChangeState();
        this.updateEditedCollection();
        this.isInEditMode = false;
    };
    CollectionEditCtrl.prototype.saveChanges = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var originalCollection, drawState, result, error_1;
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        e.preventDefault();
                        if (!((_a = this.changeState) === null || _a === void 0 ? void 0 : _a.isValid)) {
                            return [2 /*return*/];
                        }
                        if (!page_state_1.CurrentState.CollectionEdit.isDirty) {
                            return [2 /*return*/];
                        }
                        if (this.isSaving) {
                            return [2 /*return*/];
                        }
                        originalCollection = this.collection;
                        drawState = (_b = page_state_1.CurrentState.CollectionEdit.currentDraw) === null || _b === void 0 ? void 0 : _b.state;
                        if (!originalCollection) {
                            return [2 /*return*/];
                        }
                        this.setSaving(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.HOA, core_api_1.TimingEventAction.EXIT, originalCollection.id, new Date());
                        return [4 /*yield*/, services_1.Services.Collection.save(originalCollection)];
                    case 2:
                        result = _c.sent();
                        this.collectionCommitted(result, originalCollection, drawState);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        this.setSaving(false);
                        services_1.Services.Log.Logger.error("".concat(error_1));
                        notification_service_1.NotificationService.error({
                            key: index_1.T.COLLECTION_EDIT_SAVE_ERROR
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CollectionEditCtrl.prototype.setSaving = function (save) {
        this.isSaving = save;
    };
    CollectionEditCtrl.prototype.collectionCommitted = function (collection, originalCollection, drawState) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.changeState) {
                    services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.PHOTOMEASURE, core_api_1.TimingEventAction.ENTER, originalCollection.id, new Date(this.changeState.startTime));
                    services_1.Services.Analytics.trackTiming(core_api_1.TimingEventType.PHOTOMEASURE, core_api_1.TimingEventAction.EXIT, originalCollection.id, new Date());
                    this.changeState.startTime = Date.now();
                }
                (0, mobx_1.runInAction)(function () {
                    page_state_1.CurrentState.setInspectedCollection(collection.revision, page_state_1.CurrentState.inspectedCaptureId);
                    // PM page will have an IkeDraw. The map page will not.
                    if (page_state_1.CurrentState.CollectionEdit.currentDraw != null && drawState) {
                        page_state_1.CurrentState.CollectionEdit.currentDraw.state.setFromState(drawState);
                    }
                    _this.setSaving(false);
                });
                return [2 /*return*/];
            });
        });
    };
    CollectionEditCtrl.prototype.toggleFieldDetail = function (fieldId) {
        if (this.isFieldDetailShown.get(fieldId)) {
            this.isFieldDetailShown.delete(fieldId);
        }
        else {
            this.isFieldDetailShown.set(fieldId, true);
        }
    };
    CollectionEditCtrl.prototype.clearModalField = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, modal_service_1.ModalService.open({
                            title: index_1.T.FILE_DELETE_TITLE,
                            content: (0, index_1.Translate)(index_1.T.FILE_DELETE_MESSAGE, field.value),
                            okName: index_1.T.FILE_DELETE,
                            hasCancel: true
                        })];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            this.clearField(field);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionEditCtrl.prototype.clearField = function (field) {
        var _a;
        if (core_shared_1.CaptureProvider.isCaptureProvider(field) && page_state_1.CurrentState.inspectedCaptureId && field.getOwnedCaptureIds().includes(page_state_1.CurrentState.inspectedCaptureId)) {
            page_state_1.CurrentState.inspectedCaptureId = null;
        }
        field.Mutator.clear();
        var state = (_a = this.changeState) === null || _a === void 0 ? void 0 : _a.getState(field.id);
        if (state != null) {
            state.setValue(null);
        }
    };
    /**
     * File upload related functions
     */
    CollectionEditCtrl.prototype.onDragOver = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = theme_1.DefaultTheme.color.accent;
    };
    CollectionEditCtrl.prototype.onDragLeave = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.removeProperty('backgroundColor');
    };
    CollectionEditCtrl.prototype.onDragEnd = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.removeProperty('backgroundColor');
    };
    CollectionEditCtrl.prototype.selectAnchorField = function (e, field) {
        var _a, _b, _c;
        e.preventDefault();
        services_1.Services.Log.Logger.warn("1. Anchor is edit by user ".concat((_a = services_1.Services.User.current) === null || _a === void 0 ? void 0 : _a.email.toString(), " in department ").concat((_b = services_1.Services.Department.current) === null || _b === void 0 ? void 0 : _b.name.toString(), " of organization ").concat((_c = services_1.Services.Department.currentOrg) === null || _c === void 0 ? void 0 : _c.name.toString()));
    };
    CollectionEditCtrl.prototype.openFileDialog = function (e, field) {
        e.preventDefault();
        var fileInput = document.getElementById(field.id);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    };
    CollectionEditCtrl.prototype.openImageDialog = function (e, field) {
        e.preventDefault();
        var imageInput = document.getElementById(field.id);
        if (imageInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        imageInput.dispatchEvent(evt);
    };
    CollectionEditCtrl.prototype.onImage = function (e, field) {
        var imageInput = e.target;
        if (imageInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:click', 'button', 1);
        if (imageInput.files) {
            this.loadImages(imageInput.files, field);
        }
    };
    CollectionEditCtrl.prototype.onFile = function (e, field) {
        var fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:click', 'button', 1);
        if (fileInput.files) {
            this.loadFiles(fileInput.files, field);
        }
    };
    CollectionEditCtrl.prototype.update = function (e, field) {
        e.preventDefault();
        if (e.dataTransfer == null) {
            return;
        }
        var files = e.dataTransfer.files;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:drop', 'drop', 1);
        this.loadFiles(files, field);
    };
    CollectionEditCtrl.prototype.loadImages = function (images, field) {
        this.image = null;
        if (images && images[0]) {
            var image = images[0];
            if (this.maxImageSize < image.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:large', 'large', image.size);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_TOO_LARGE });
                this.unsetLoading(field.id);
                return;
            }
            var imageType = image.type.toLowerCase();
            if (this.allowedTypes.length > 0 && imageType !== '' && this.allowedTypes.indexOf(imageType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:type', imageType, 1);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
                this.unsetLoading(field.id);
                return;
            }
            this.image = new upload_reader_1.ImageUploadReader(image, field);
        }
    };
    CollectionEditCtrl.prototype.loadFiles = function (files, field) {
        this.file = null;
        if (files == null) {
            return;
        }
        if (files.length > 1) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:count', String(files.length), 1);
            notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
            this.unsetLoading(field.id);
            return;
        }
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (!file) {
                throw new Error("undefined File recieved from FileList at index ".concat(i));
            }
            if (this.maxFileSize < file.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:large', 'large', file.size);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_TOO_LARGE });
                this.unsetLoading(field.id);
                continue;
            }
            var fileType = file.type.toLowerCase();
            if (this.allowedTypes.length > 0 && fileType !== '' && this.allowedTypes.indexOf(fileType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:type', fileType, 1);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
                this.unsetLoading(field.id);
                continue;
            }
            this.file = new upload_reader_1.FileUploadReader(file, field);
        }
    };
    CollectionEditCtrl.prototype.processFile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, attachment, metadata, error_2, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.file) {
                            return [2 /*return*/];
                        }
                        this.setLoading(this.file.field.id);
                        if (!this.file.buffer) return [3 /*break*/, 8];
                        rest = services_1.Services.Department.rest;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, rest.Attachment.set(this.file.name, this.file.buffer, this.file.type)];
                    case 2:
                        attachment = _a.sent();
                        rest.Attachment.antivirusScan(attachment.objectId);
                        metadata = {};
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, rest.Attachment.parse(attachment.objectId)];
                    case 4:
                        metadata = _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        services_1.Services.Log.Logger.info("File cannot be parsed: ".concat(error_2));
                        return [3 /*break*/, 6];
                    case 6:
                        this.file.field.Mutator.manual({
                            filename: this.file.name,
                            attachmentId: attachment.objectId,
                            size: attachment.size,
                            metadata: metadata
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        this.unsetLoading(this.file.field.id);
                        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                        return [3 /*break*/, 8];
                    case 8:
                        this.unsetLoading(this.file.field.id);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionEditCtrl.prototype.processImage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, capture, e_2;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.image) === null || _a === void 0 ? void 0 : _a.buffer)) return [3 /*break*/, 5];
                        this.setLoading(this.image.field.id);
                        rest = services_1.Services.Department.rest;
                        capture = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, rest.Capture.Image.image(core_shared_1.IkeId.v4(), this.image.buffer, 1, new Date())];
                    case 2:
                        capture = _b.sent();
                        rest.Capture.antivirus({ captureId: capture.objectId });
                        this.image.field.Mutator.add(capture.objectId);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                        services_1.Services.Log.Logger.info("Image cannot be parsed: ".concat(e_2));
                        return [3 /*break*/, 4];
                    case 4:
                        this.unsetLoading(this.image.field.id);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CollectionEditCtrl.prototype.fileDownload = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, url, options;
            var _this = this;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                if (field.attachmentId) {
                    this.setLoading(field.id);
                    token = "Bearer ".concat(services_1.Services.SSO.token);
                    url = '/v1/file/' + field.attachmentId + '?departmentId=' + ((_a = services_1.Services.Department.current) === null || _a === void 0 ? void 0 : _a.objectId);
                    options = {
                        headers: {
                            Authorization: token
                        }
                    };
                    // @todo this needs to be refactored to use the rest classes
                    fetch(url, options)
                        .then(function (res) {
                        if (!res.ok) {
                            services_1.Services.Log.Logger.error('File possibly infected');
                            notification_service_1.NotificationService.error({
                                key: index_1.T.ERROR_DOWNLOAD_FAIL
                            });
                            return null;
                        }
                        return res.blob();
                    })
                        .then(function (blob) {
                        var _a;
                        if (blob != null) {
                            var file = window.URL.createObjectURL(blob);
                            var link = services_1.Services.Window.document.createElement('a');
                            link.download = (_a = field.value) !== null && _a !== void 0 ? _a : '';
                            link.href = file;
                            services_1.Services.Window.document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }
                        _this.unsetLoading(field.id);
                    })
                        .catch(function (e) {
                        services_1.Services.Log.Logger.error(e, 'File download error');
                        notification_service_1.NotificationService.error({
                            key: index_1.T.ERROR_GENERAL
                        });
                        _this.unsetLoading(field.id);
                    });
                }
                return [2 /*return*/, false];
            });
        });
    };
    CollectionEditCtrl.prototype.setLoading = function (fieldId) {
        this.isInUploadMode = true;
        this.fieldsInLoadingState.push(fieldId);
    };
    CollectionEditCtrl.prototype.unsetLoading = function (fieldId) {
        this.isInUploadMode = false;
        this.fieldsInLoadingState.splice(this.fieldsInLoadingState.indexOf(fieldId), 1);
    };
    /**
     * File upload related functions end
     */
    CollectionEditCtrl.prototype.fillAddressDisabled = function (field) {
        if (field.value) {
            return true;
        }
        if (this.location() == null) {
            return true;
        }
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        return false;
    };
    CollectionEditCtrl.prototype.geocodingButtonTitle = function (field) {
        if (field.value) {
            return 'Already has value';
        }
        if (this.location() == null) {
            return 'There is no location';
        }
        return 'Get address';
    };
    CollectionEditCtrl.prototype.location = function () {
        var revision = page_state_1.CurrentState.inspectedCollectionRevision;
        if (!revision) {
            return null;
        }
        var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        var location = collectionSummary.location;
        if (!(location && location.coordinates)) {
            return null;
        }
        return location;
    };
    CollectionEditCtrl.prototype.fillAddress = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location, addressFields, address, fieldState, metadata, city, state, cityFieldId, cityFieldState, stateFieldId, stateFieldState;
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        location = this.location();
                        if (location == null) {
                            return [2 /*return*/];
                        }
                        if (!this.changeState) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, services_1.Services.Geocoder.getAddress(location)];
                    case 1:
                        addressFields = _c.sent();
                        address = addressFields.address;
                        fieldState = this.changeState.getState(field.id);
                        fieldState.setValue(address);
                        if (address === (0, index_1.Translate)(index_1.T.ERROR_GENERAL)) {
                            fieldState.setError(address);
                        }
                        metadata = field.collection.schema.metadata;
                        city = addressFields.city;
                        state = addressFields.state;
                        if (city && ((_a = metadata.options.address_lookup) === null || _a === void 0 ? void 0 : _a.city)) {
                            cityFieldId = metadata.options.address_lookup.city.field;
                            cityFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, cityFieldId));
                            if (cityFieldState) {
                                cityFieldState.setValue(city);
                            }
                        }
                        if (state && ((_b = metadata.options.address_lookup) === null || _b === void 0 ? void 0 : _b.state)) {
                            stateFieldId = metadata.options.address_lookup.state.field;
                            stateFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, stateFieldId));
                            if (stateFieldState) {
                                stateFieldState.setValue(state);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionEditCtrl.prototype.clearError = function (field) {
        if (!this.changeState) {
            return;
        }
        var fieldState = this.changeState.getState(field.id);
        fieldState.setValue('');
        fieldState.setError('');
    };
    CollectionEditCtrl.prototype.clearErrorDisabled = function (field) {
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        if (!this.changeState) {
            return true;
        }
        var state = this.changeState.getState(field.id);
        if (state.hasError() === true) {
            return false;
        }
        return true;
    };
    CollectionEditCtrl.prototype.isExpanded = function (instanceId) {
        var _a;
        if (this.isAllExpanded) {
            return this.isFormOpen.get(instanceId) !== false;
        }
        return (_a = this.isFormOpen.get(instanceId)) !== null && _a !== void 0 ? _a : false;
    };
    CollectionEditCtrl.prototype.toggleExpanded = function (e, instanceId) {
        e.preventDefault();
        var prev = this.isFormOpen.get(instanceId);
        if (prev == null) {
            prev = this.isAllExpanded;
        }
        this.isFormOpen.set(instanceId, !prev);
        return false;
    };
    CollectionEditCtrl.prototype.setZoomWindow = function (show) {
        this.isZoomShown = show;
    };
    CollectionEditCtrl.prototype.zoomToCollection = function () {
        if (page_state_1.CurrentState.inspectedCollectionRevision) {
            this.mapState.zoomToCollection(page_state_1.CurrentState.inspectedCollectionRevision);
        }
    };
    CollectionEditCtrl.prototype.toggleMetaInfo = function () {
        this.isMetadataShown = !this.isMetadataShown;
        this.isZoomShown = false;
    };
    CollectionEditCtrl.prototype.toggleZoomWindow = function () {
        var _a;
        this.isZoomShown = !this.isZoomShown;
        this.isMetadataShown = false;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, "zoom:".concat(this.isZoomShown ? 'show' : 'hide'), (_a = this.collection) === null || _a === void 0 ? void 0 : _a.revision);
    };
    CollectionEditCtrl.prototype.toggleExpandAll = function () {
        var _a;
        this.isAllExpanded = !this.isAllExpanded;
        this.isFormOpen.clear();
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, "form:".concat(this.isAllExpanded ? 'expand' : 'collapse'), (_a = this.collection) === null || _a === void 0 ? void 0 : _a.revision);
    };
    CollectionEditCtrl.prototype.enterEditMode = function () {
        if (!page_state_1.CurrentState.inspectedCollectionRevision) {
            return;
        }
        var collection = store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
        if (collection != null) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'Collection:edit', collection.uuid, 1);
        }
        this.isInEditMode = true;
    };
    CollectionEditCtrl.prototype.exitEditMode = function () {
        if (page_state_1.CurrentState.CollectionEdit.isDirty) {
            throw new Error('Must discard changes before exiting collection edit mode');
        }
        this.isInEditMode = false;
    };
    CollectionEditCtrl.prototype.stopNavigation = function () {
        return page_state_1.CurrentState.CollectionEdit.isDirty;
    };
    CollectionEditCtrl.prototype.beginSpanLink = function (c) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, state, result, spanLinkRecord;
            var _this = this;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        collection = c.collection;
                        state = new span_link_chooser_state_1.SpanLinkChooserState(collection);
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: multi_list_chooser_1.MultiListChooserTitle.view(state),
                                content: function () { return multi_list_chooser_1.MultiListChooserContent.view(state); },
                                className: multi_list_chooser_style_1.CSS.modal,
                                hasCancel: true
                            })];
                    case 1:
                        result = _b.sent();
                        if (!result.ok) {
                            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link:cancel', (_a = this.collection) === null || _a === void 0 ? void 0 : _a.revision);
                            return [2 /*return*/];
                        }
                        if (state.value == null) {
                            state.selectDefaultValue();
                        }
                        spanLinkRecord = state.getSelectedSpanLinkRecord();
                        if (spanLinkRecord == null) {
                            return [2 /*return*/];
                        }
                        (0, mobx_1.runInAction)(function () {
                            var _a;
                            try {
                                var newSubformInstance = services_1.Services.SubFormLink.copySubForm(collection, spanLinkRecord);
                                notification_service_1.NotificationService.success({
                                    key: index_1.T.SPAN_LINK_SUCCESS,
                                    attrs: {
                                        toSpan: newSubformInstance.title,
                                        fromCollection: spanLinkRecord.collection.title
                                    }
                                });
                                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link', (_a = _this.collection) === null || _a === void 0 ? void 0 : _a.revision);
                            }
                            catch (e) {
                                services_1.Services.Log.Logger.error("Span link failed: ".concat(e));
                                notification_service_1.NotificationService.error({
                                    key: index_1.T.ERROR_GENERAL
                                });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CollectionEditCtrl.prototype, "matches", {
        get: function () {
            if (this.collection == null || !services_1.Services.Measurement.isFormSupported(this.collection.schema)) {
                return [];
            }
            return services_1.Services.Measurement.getFieldJoins(this.collection);
        },
        enumerable: false,
        configurable: true
    });
    CollectionEditCtrl.prototype.getJoin = function (field) {
        for (var _i = 0, _a = this.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            var join = match.getJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    };
    CollectionEditCtrl.prototype.getOppositeJoin = function (field) {
        for (var _i = 0, _a = this.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            var join = match.getOppositeJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    };
    CollectionEditCtrl.prototype.chooseLinkingCollection = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                page_state_1.CurrentState.CollectionLink.beginLinking(field.id);
                return [2 /*return*/, new Promise(function (resolve) {
                        var disposer = (0, mobx_1.reaction)(function () { return page_state_1.CurrentState.CollectionLink.isLinking; }, function () {
                            disposer();
                            var revision = page_state_1.CurrentState.CollectionLink.collectionRevision;
                            if (revision == null) {
                                resolve(null);
                            }
                            var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                            resolve(collectionSummary);
                        });
                    })];
            });
        });
    };
    CollectionEditCtrl.prototype.canInspectCollection = function (summary) {
        if (summary == null) {
            return false;
        }
        var id = summary.tags[0];
        if (!id) {
            return false;
        }
        var tag = store_1.AppStore.Tag.get(id);
        if (!tag) {
            return false;
        }
        return services_1.Services.Search.includesTag(tag);
    };
    CollectionEditCtrl.prototype.inspectCollection = function (revision) {
        this.mapState.zoomToCollection(revision);
    };
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], CollectionEditCtrl.prototype, "changeState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isAllExpanded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isInEditMode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isSaving", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isMetadataShown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isZoomShown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isPhotomeasure", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "isInUploadMode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionEditCtrl.prototype, "fieldsInLoadingState", void 0);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], CollectionEditCtrl.prototype, "file", void 0);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], CollectionEditCtrl.prototype, "image", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "clearOpenState", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "updateEditedCollection", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "abortChanges", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "discardAndDestroyEdit", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "saveChanges", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "setSaving", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "toggleFieldDetail", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "clearModalField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "clearField", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "onDragOver", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "onDragLeave", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "onDragEnd", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "selectAnchorField", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "openFileDialog", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "openImageDialog", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "onImage", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "onFile", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "update", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "processFile", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "processImage", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "fileDownload", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "fillAddress", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "clearError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "toggleExpanded", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "setZoomWindow", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "zoomToCollection", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "toggleMetaInfo", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "toggleZoomWindow", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "toggleExpandAll", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "enterEditMode", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditCtrl.prototype, "exitEditMode", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], CollectionEditCtrl.prototype, "stopNavigation", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionEditCtrl.prototype, "matches", null);
    return CollectionEditCtrl;
}(mobx_2.MobxState));
exports.CollectionEditCtrl = CollectionEditCtrl;
//# sourceMappingURL=collection.view.ctrl.js.map